/* eslint-disable linebreak-style */
import React from 'react';

const Notfound = () => {
  return (<p className="notfound">Sorry! Page not found 👻</p>)
}

export default Notfound;